var map = {
	"./Allgaeuer-OElmuehle.png": 8819,
	"./Baur_Metzgerei.jpg": 878,
	"./Logo_Tafel_Deutschland_e.V..png": 4855,
	"./Roesternest_logo.png": 5315,
	"./Vogtmuehlen.png": 9517,
	"./allgaeu_karte.webp": 6015,
	"./baeko.jpg": 5563,
	"./bio.png": 3004,
	"./botzenhard.png": 1011,
	"./dallmayr.png": 9162,
	"./fairtrade.png": 2731,
	"./haerle.jpg": 6444,
	"./heimbs.png": 3175,
	"./koellemann_sig.jpg": 2735,
	"./kurz.jpg": 5215,
	"./maucher.png": 6574,
	"./memminger-brauerei.png": 9191,
	"./notausgang.png": 7072,
	"./pfersich.png": 7895,
	"./steinhauser.png": 9520,
	"./uaw.jpg": 8294,
	"./uhl-meuhle.png": 8503,
	"./vierlande.png": 2044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9016;